import type {V1RequestContext} from '../v1Context';

export default function mergeContextVariables(
  v1Context: V1RequestContext,
  v1Variables: Partial<V1RequestContext> | null | undefined,
): V1RequestContext {
  const searchSessionId =
    v1Variables?.searchSessionId ?? v1Context.searchSessionId;

  return {
    accountId: v1Variables?.accountId ?? v1Context.accountId,
    apiKey: v1Variables?.apiKey ?? v1Context.apiKey,
    betaHeaders: v1Variables?.betaHeaders ?? v1Context?.betaHeaders,
    liveMode: v1Variables?.liveMode ?? v1Context.liveMode,
    id: v1Variables?.id ?? v1Context.id,
    ...(searchSessionId ? {searchSessionId} : {}),
  };
}
